<template>
  <StockLockList is-verify />
</template>
<script>
import StockLockList from '@/views/center-business/stock/lock/index';
export default {
  name: 'BusinessStockVerifyLockIndex',
  components: {
    StockLockList,
  },
  mixins: [],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped></style>
